var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxoutlinesearchEg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, " -->\n", /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.93333 4.66667L1.06667 1.86667L2.93333 3.53333C2.93333 3.53333 5.2 1.2 5.2 1.2C4.66667 0.466667 3.86667 0 2.86667 0C1.26667 0 0 1.26667 0 2.86667C0 4.46667 1.26667 5.73333 2.86667 5.73333C4.46667 5.73333 5.73333 4.46667 5.73333 2.86667C5.73333 2.33333 5.6 1.86667 5.4 1.46667C5.4 1.46667 2.93333 4.66667 2.93333 4.66667L2.93333 4.66667ZM2.93333 1.2C3.26667 1.2 3.6 1.46667 3.6 1.86667C3.6 2.2 3.33333 2.53333 2.93333 2.53333C2.53333 2.53333 2.26667 2.26667 2.26667 1.86667C2.26667 1.46667 2.6 1.2 2.93333 1.2C2.93333 1.2 2.93333 1.2 2.93333 1.2Z",
    transform: "translate(4.733 4.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 0C1.66667 0 0 1.73333 0 1.73333C0.0666666 1.8 0.133333 1.93333 0.2 2C0.2 2 1.66667 0 1.66667 0L1.66667 0Z",
    transform: "translate(9.933 4.267)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8 0C3.06667 0 0 3 0 6.8C0 10.5333 3.06667 13.6 6.8 13.6C10.5333 13.6 13.6 10.5333 13.6 6.8C13.6 3.06667 10.5333 0 6.8 0C6.8 0 6.8 0 6.8 0ZM6.8 12.6667C3.53333 12.6667 0.933333 10 0.933333 6.8C0.933333 3.6 3.53333 0.933333 6.8 0.933333C10.0667 0.933333 12.6667 3.53333 12.6667 6.8C12.6667 10.0667 10.0667 12.6667 6.8 12.6667C6.8 12.6667 6.8 12.6667 6.8 12.6667Z",
    transform: "translate(0.8 0.867)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.48333 2.21667C1.48333 2.21667 0.149999 0.883334 0.149999 0.883334C-0.0500002 0.683334 -0.0500002 0.350001 0.149999 0.150001C0.349998 -0.0499992 0.683331 -0.0499992 0.883332 0.150001C0.883332 0.150001 2.21667 1.48333 2.21667 1.48333C2.41667 1.68333 2.41667 2.01667 2.21667 2.21667C2.15 2.28333 2.01667 2.35 1.88333 2.35C1.68333 2.35 1.55 2.35 1.48333 2.21667C1.48333 2.21667 1.48333 2.21667 1.48333 2.21667Z",
    transform: "translate(12.85 12.783)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxoutlinesearchEg);
export default __webpack_public_path__ + "static/media/vuesaxoutlinesearch-eg.5e5c18bbda8c05c5afddc2f58edd9ed2.svg";
export { ForwardRef as ReactComponent };